import { Box, Button, Typography } from "@mui/material";

import { styled } from "@mui/material/styles";

export const MatchmakerLogo = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  objectPosition: 'center',
  maxWidth: '60px',
  display: 'block',
  borderRadius: '8px',
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
}))

export const ModalSubtitle = styled(Typography)(({ theme }) => ({
  textAlign: "center"
}))

export const ModalButton = styled(Button)(({ theme }) => ({
  border: "1px solid",
  fontWeight: 700,
  fontSize: "16px",
  borderColor: theme.colors.primary.slalomBlue,
  color: theme.colors.primary.slalomBlue,
  
}))

export const PhotoContainer = styled("img")(({ theme }) => ({
  display: "flex",
  height: "100%",
  width: "100%",
  objectFit: "cover",
}))

export const SuccessModalContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  maxWidth: "320px",
  gap: "25px",
}));

export const SuccessImage = styled("img")(({ theme }) => ({
  maxWidth: "80px"
}));